module.exports = __webpack_public_path__ + "img/ticketcz_active.5132a173.png";